// extracted by mini-css-extract-plugin
module.exports = {"iconbutton":"iconbutton_iconbutton__3rfub","animation":"iconbutton_animation__2uDOm","children":"iconbutton_children__3IX6w"};